import { object, string, number } from "yup";
import { Fragments } from "requests";

export const getValidation = (
  initialValues: Fragments.StoredDiagnosticTesting,
  isDoctorRequired: boolean
) => ({
  validationSchema: object().shape({
    abnormalitiesAndNotes: string(),
    reviewedByDvm: string().nullable(),
    doctor: isDoctorRequired
      ? number()
          .nullable()
          .required()
      : number().nullable()
  }),
  defaultValues: {
    abnormalitiesAndNotes: initialValues?.abnormalitiesAndNotes || "",
    reviewedByDvm:
      initialValues?.reviewedByDvm == null
        ? null
        : initialValues.reviewedByDvm.toString(),
    doctor: initialValues?.doctor || null
  }
});
